const EMPTY_VALUES = new Set([undefined, null, '', 'undefined', 'null']);

export function sanitizeParams(params = {}) {
    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => !EMPTY_VALUES.has(value))
    );
}

export function buildQueryString(params = {}) {
    const sanitized = sanitizeParams(params);
    const query = new URLSearchParams();

    Object.entries(sanitized).forEach(([key, value]) => {
        query.append(key, value);
    });

    return query.toString();
}

export function pathSegment(value) {
    return EMPTY_VALUES.has(value) ? '' : value;
}
